<template>
	<div>
		<filter-reports
			@generate-report="clickGenerate"
			v-if="showFilters"
			name-report="Reporte de Envíos Individuales"
			:add-user-select="false"
		/>
		<CRow class="justify-content-center" v-if="showReport">
			<CCol md="12">
				<CCard>
					<CCardHeader style="background: #97ca3d;color: #000000;">
						<h4>Reporte de Envíos Individuales</h4>
					</CCardHeader>
					<CCardBody>
						<div v-if="showNotFound">
							<CRow class="content-left">
								<CCol sm="12">
									<p>
										No se econtrarón envíos para la fecha
										ingresada. Por favor intenta ingresar
										otra fecha.
									</p>
								</CCol>
							</CRow>
							<CRow class="content-center">
								<CCol sm="12">
									<b-button
										@click="generateNewReport"
										style="margin-top: 10px;"
										pill
										variant="success"
									>
										Cambiar la Fecha</b-button
									>
								</CCol>
							</CRow>
						</div>
						<div v-if="showResume">
							<p>Resumen de Envíos</p>
							<table-for-reports
								:pagination="false"
								:fields-table="fieldsTableReport"
								:table="tableForReport"
								:total-rows="totalRows"
							/>
							<CRow class="content-center">
								<CCol sm="4">
									<export-excel
										:data-to-export="dataToExport"
										file-name="Resumen Envíos Individuales"
									/>
								</CCol>
								<CCol sm="4">
									<b-button
										@click="generateNewReport"
										style="margin-top: 10px;"
										pill
										variant="success"
									>
										Generar Otro Reporte</b-button
									>
								</CCol>
								<CCol sm="4">
									<b-button
										@click="showReportDetails"
										style="margin-top: 10px;"
										pill
										variant="primary"
									>
										Ver detalle del reporte</b-button
									>
								</CCol>
							</CRow>
						</div>
						<div v-if="showDetails">
							<CRow>
								<CCol sm="12">
									<table-for-reports
										:fields-table="fieldsTableDetails"
										:table="tableForDetails"
										:total-rows="totalRows"
									/>
									<CRow class="content-left">
										<CCol sm="12">
											<export-excel
												:data-to-export="
													dataToExportDetails
												"
												file-name="Solicitudes de Envío Individual"
											/>
										</CCol>
									</CRow>
									<CRow class="content-center">
										<CCol sm="12">
											<b-button
												@click="generateNewReport"
												style="margin-top: 10px"
												pill
												variant="success"
											>
												Generar Otro Reporte</b-button
											>
										</CCol>
									</CRow>
								</CCol>
							</CRow>
						</div>
						<!-- vista detalle agrupado en pestanhas, se comenta esta funcion por los momentos -->
						<!-- <div v-if="showDetails">
							<CRow>
								<CCol sm="12">
									<b-tabs pills>
										<b-tab
											title="Solicitudes Procesadas"
											active
										>
											<table-for-reports
												:fields-table="
													fieldsTableDetails
												"
												:table="tableDetailProcessed"
												:total-rows="totalRows"
											/>
											<CRow class="content-left">
												<CCol sm="12">
													<export-excel
														:data-to-export="
															dataToExportProcessed
														"
														file-name="Solicitudes Procesadas"
													/>
												</CCol>
											</CRow>
										</b-tab>
										<b-tab title="Solicitudes Rechazadas">
											<table-for-reports
												:fields-table="
													fieldsTableDetails
												"
												:table="tableDetailsRejected"
												:total-rows="totalRows"
											/>
											<CRow class="content-left">
												<CCol sm="12">
													<export-excel
														:data-to-export="
															dataToExportRejected
														"
														file-name="Solicitudes Rechazadas"
													/>
												</CCol>
											</CRow>
										</b-tab>
									</b-tabs>
									<CRow class="content-center">
										<CCol sm="12">
											<b-button
												@click="generateNewReport"
												style="margin-top: 10px;"
												pill
												variant="success"
											>
												Generar Otro Reporte</b-button
											>
										</CCol>
									</CRow>
								</CCol>
							</CRow>
						</div> -->
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>
<script>
	import functionsReports from '../../functions/functionsForReports';
	import exportExcel from '../../components/exportExcel.vue';
	import FilterReports from '../../components/filterReports.vue';
	import tableForReports from '../../components/tableForReports';
	/*Componente para el reporte de envíos individuales enviados. */
	export default {
		name: 'reportSingleRequestSended',
		title: 'Reporte Solicitudes Procesadas | Infoguia',
		components: {
			exportExcel,
			FilterReports,
			tableForReports,
		},
		data() {
			return {
				showFilters: true,
				showReport: false,
				showNotFound: false,
				showDetails: false,
				showResume: false,
				fieldsTableReport: [
					{
						key: 'quantitySent',
						label: 'Cantidad de Envíos',
					},
					{
						key: 'quantityVisualized',
						label: 'Cantidad Visualizaciones',
						//tdClass: 'content-right',
					},
					{
						key: 'quantityFilled',
						label: 'Cantidad de Solicitudes Recibidas',
						//tdClass: 'content-right',
					},
					{
						key: 'quantityProcessed',
						label: 'Cantidad de Solicitudes Procesadas',
						//tdClass: 'content-right',
					},
					{
						key: 'quantityRejected',
						label: 'Cantidad de Solicitudes Rechazadas',
						//tdClass: 'content-right',
					},
				],
				fieldsTableDetails: [
					{
						key: 'bussinessName',
						label: 'Nombre de la Empresa',
					},
					{
						key: 'sendingDate',
						label: 'Fecha de Envío',
						//tdClass: 'content-right',
					},
					{
						key: 'status',
						label: 'Estatus',
						//tdClass: 'content-right',
					},
					{
						key: 'userName',
						label: 'Usuario',
						//tdClass: 'content-right',
					},
				],
				tableForReport: [],
				// tableDetailsRejected: [],
				// tableDetailProcessed: [],
				tableForDetails: [],
				dataToExport: [],
				dataToExportDetails: [],
				// dataToExportRejected: [],
				// dataToExportProcessed: [],
				totalRows: 0,
			};
		},
		created() {},
		methods: {
			clickGenerate(dataForPost) {
				this.loadReport(dataForPost);
			},
			loadReport(dataForPost) {
				let loader = this.$loading.show();
				let quantitySent = 0;
				functionsReports
					.getReportSingleRequests(dataForPost)
					.then((response) => {
						this.totalRows = response.length;
						for (let index = 0; index < response.length; index++) {
							quantitySent = response[index].quantitySent;
							this.tableForReport[index] = {
								quantitySent: response[index].quantitySent,
								quantityVisualized:
									response[index].quantityVisualized,
								quantityFilled: response[index].quantityFilled,
								quantityProcessed:
									response[index].quantityProcessed,
								quantityRejected:
									response[index].quantityRejected,
								_rowVariant: '',
							};
							this.dataToExport[index] = {
								'Cantidad de Envíos':
									response[index].quantitySent,
								'Cantidad Visualizaciones':
									response[index].quantityVisualized,
								'Cantidad de Solicitudes Recibidas':
									response[index].quantityFilled,
								'Cantidad de Solicitudes Procesadas':
									response[index].quantityProcessed,
								'Cantidad de Solicitudes Rechazadas':
									response[index].quantityRejected,
							};
						}
						if (
							this.tableForReport.length > 0 &&
							quantitySent > 0
						) {
							this.showReport = true;
							this.showFilters = false;
							this.showResume = true;
						} else {
							this.showReport = true;
							this.showFilters = false;
							this.showNotFound = true;
						}
						this.loadDetails(dataForPost);
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			loadDetails(dataForPost) {
				let loader = this.$loading.show();
				functionsReports
					.getReportSingleRequestsDetails(dataForPost)
					.then((response) => {
						this.totalRows = response.length;
						let statusDescription = '';
						for (let reportDetails of Object.keys(response)) {
							statusDescription =
								response[reportDetails].status.description !==
								''
									? ' (' +
									  response[reportDetails].status
											.description +
									  ')'
									: '';
							this.tableForDetails[reportDetails] = {
								bussinessName:
									response[reportDetails].busquedaempresa
										.nombreempresa,
								sendingDate:
									response[reportDetails].sendingDate,
								status:
									response[reportDetails].status.name +
									statusDescription,
								userName: response[reportDetails].user.name,
							};
							this.dataToExportDetails[reportDetails] = {
								'Nombre de la Empresa':
									response[reportDetails].busquedaempresa
										.nombreempresa,
								'Fecha del Envío':
									response[reportDetails].sendingDate,
								'Estatus de la Solicitud':
									response[reportDetails].status.name +
									statusDescription,
								'Usuario Encargado':
									response[reportDetails].user.name,
							};
						}
						// let requestsRejected = response.filter(
						// 	(el) => el.idstatus === 12
						// );
						// let requestsProcessed = response.filter(
						// 	(el) => el.idstatus === 10
						// );
						// for (let rejected of Object.keys(requestsRejected)) {
						// 	this.tableDetailsRejected[rejected] = {
						// 		bussinessName:
						// 			requestsRejected[rejected].busquedaempresa
						// 				.nombreempresa,
						// 		sendingDate:
						// 			requestsRejected[rejected].sendingDate,
						// 		status: requestsRejected[rejected].status.name,
						// 		userName: requestsRejected[rejected].user.name,
						// 	};
						// 	this.dataToExportRejected[rejected] = {
						// 		'Nombre de la Empresa':
						// 			requestsRejected[rejected].busquedaempresa
						// 				.nombreempresa,
						// 		'Fecha del Envío':
						// 			requestsRejected[rejected].sendingDate,
						// 		'Estatus de la Solicitud':
						// 			requestsRejected[rejected].status.name,
						// 		'Usuario Encargado':
						// 			requestsRejected[rejected].user.name,
						// 	};
						// }
						// for (let processed of Object.keys(requestsProcessed)) {
						// 	this.tableDetailProcessed[processed] = {
						// 		bussinessName:
						// 			requestsProcessed[processed].busquedaempresa
						// 				.nombreempresa,
						// 		sendingDate:
						// 			requestsProcessed[processed].sendingDate,
						// 		status:
						// 			requestsProcessed[processed].status.name,
						// 		userName:
						// 			requestsProcessed[processed].user.name,
						// 	};
						// 	this.dataToExportProcessed[processed] = {
						// 		'Nombre de la Empresa':
						// 			requestsProcessed[processed].busquedaempresa
						// 				.nombreempresa,
						// 		'Fecha del Envío':
						// 			requestsProcessed[processed].sendingDate,
						// 		'Estatus de la Solicitud':
						// 			requestsProcessed[processed].status.name,
						// 		'Usuario Encargado':
						// 			requestsProcessed[processed].user.name,
						// 	};
						// }
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			generateNewReport() {
				this.showReport = false;
				this.showFilters = true;
				this.showNotFound = false;
				this.showDetails = false;
				this.showResume = false;
				this.tableForReport = [];
			},
			showReportDetails() {
				//this.showReport = false
				this.showDetails = true;
				this.showResume = false;
			},
		},
	};
</script>
